import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import './modal.css'
import { GC_USER_ID } from '@/constants'
import { routineQuery } from '@/graphql/queries/routine'
import {
  newRoutine,
  updateRoutine,
  removeFromRoutinesOnGroup,
  deleteRoutine
} from '@/graphql/mutations/routine'
import GroupsModal from '../modals/Groups'
import DeleteModal from '../modals/Delete'
import {
  Modal,
  Typography,
  Paper,
  GridList,
  GridListTile,
  Checkbox,
  Button
} from 'material-ui'
import { FormGroup, FormControlLabel } from 'material-ui/Form'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import RemoveIcon from 'material-ui-icons/Remove'
import IconButton from 'material-ui/IconButton'
import ClearIcon from 'material-ui-icons/Clear'
import TimelapseIcon from 'material-ui-icons/Timelapse'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import Loading from './Loading'
import * as moment from 'moment'

@graphql(newRoutine, {
  name: 'newRoutine',
  options: {
    refetchQueries: ['routinesListQuery', 'routineQuery']
  }
})
@graphql(updateRoutine, {
  name: 'updateRoutine',
  options: {
    refetchQueries: ['routinesListQuery', 'routineQuery']
  }
})
@graphql(routineQuery, {
  name: 'routineQuery',
  options: ownProps => ({
    variables: {
      id: ownProps.id
    },
    refetchQueries: ['routinesListQuery']
  })
})
@graphql(deleteRoutine, {
  name: 'deleteRoutine',
  options: {
    refetchQueries: ['routinesListQuery']
  }
})
@graphql(removeFromRoutinesOnGroup, {
  name: 'removeFromRoutinesOnGroup',
  options: {
    refetchQueries: ['routineQuery', 'routinesQuery']
  }
})
export default class RoutineEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      OpenGroups: false,
      routine: '',

      loadingDel: false,
      OpenDelete: false,

      loading: false,
      loadingSave: false
    }
  }

  // reset state if the seeded prop is updated
  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.setState({ open: nextProps.open })
    }
    if (nextProps.action !== this.props.action) {
      if (nextProps.action === 'add') {
        var r = {
          name: '',
          frequency: '',
          groups: []
        }
        this.setState({ routine: r })
      }
    }

    if (nextProps.routineQuery !== this.props.routineQuery) {
      if (nextProps.routineQuery.Routine) {
        this.setState({ routine: nextProps.routineQuery.Routine })
      }
    }
  }

  handleSave = () => {
    this.setState({ loadingSave: true })
    if (this.props.action === 'add') {
      this.props
        .newRoutine({
          variables: {
            name: this.state.routine.name,
            frequency: this.state.routine.frequency,
            dateStart: moment().format(),
            type: this.state.routine.type,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false,
            routine: ''
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false,
            routine: ''
          })
        })
    } else if (this.props.action === 'edit') {
      this.props
        .updateRoutine({
          variables: {
            name: this.state.routine.name,
            frequency: this.state.routine.frequency,
            id: this.state.routine.id,
            userId: global.localStorage.getItem(GC_USER_ID)
          }
        })
        .then(() => {
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false
          })
        })
        .catch(error => {
          console.log(error.message + ' Please refresh.')
          this.props.onClose()
          this.setState({
            open: false,
            loadingSave: false
          })
        })
    }
  }

  handleClose = () => {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleOpenGroups = () => {
    this.setState({
      OpenGroups: true
    })
  }

  handleCloseGroups = () => {
    this.setState({
      OpenGroups: false
    })
  }

  handleChange = name => event => {
    var newRoutine = Object.assign({}, this.state.routine)
    switch (name) {
      case 'frequency':
        if (
          newRoutine.frequency &&
          newRoutine.frequency.includes(event.target.value)
        ) {
          newRoutine.frequency = newRoutine.frequency.replace(
            event.target.value,
            ''
          )
        } else {
          newRoutine.frequency = newRoutine.frequency.concat(event.target.value)
        }
        break
      default:
        newRoutine[name] = event.target.value
        break
    }
    this.setState({ routine: newRoutine })
  }

  handleRemove = id => {
    this.setState({ loading: true })
    this.props
      .removeFromRoutinesOnGroup({
        variables: {
          routinesRoutineId: this.state.routine.id,
          groupsGroupId: id
        }
      })
      .then(() => {
        this.setState({
          loading: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.setState({
          loading: false
        })
      })
  }

  handleOpenDelete = () => {
    this.setState({
      OpenDelete: true
    })
  }

  handleCloseDelete = () => {
    this.setState({
      OpenDelete: false
    })
  }

  handleDelete = id => {
    this.setState({ loadingDel: true })
    this.props
      .deleteRoutine({
        variables: {
          id: id
        }
      })
      .then(() => {
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
      .catch(error => {
        console.log(error.message + ' Please refresh.')
        this.props.onClose()
        this.setState({
          loadingDel: false,
          OpenDelete: false,
          open: false
        })
      })
  }

  render() {
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="modalAddToday"
          disableAutoFocus
        >
          <Paper className="paperAddToday" style={{ borderRadius: 16 }}>
            {this.props.routineQuery.loading ? (
              <Loading />
            ) : (
              <div id="GetUpTime" className="divAddTpday">
                <div className="divClearButton">
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleClose}
                  >
                    <ClearIcon className="iconClear" />
                  </IconButton>
                </div>
                <List>
                  <ListItem className="listItemSleepTimeComplete">
                    <ListItemIcon>
                      <TimelapseIcon className="editIcons" />
                    </ListItemIcon>
                    <TextField
                      id="name"
                      label="Routine Name"
                      className="textFieldLong"
                      value={this.state.routine.name}
                      onChange={this.handleChange('name')}
                      margin="normal"
                      InputLabelProps={{
                        className: 'textFieldTimeTiny'
                      }}
                      inputProps={{
                        className: 'textFieldTimeSmall'
                      }}
                    />
                  </ListItem>

                  <ListItem className="modalContentSmallTime">
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              this.state.routine.frequency &&
                              this.state.routine.frequency.includes('Mon')
                            }
                            onChange={this.handleChange('frequency')}
                            value="Mon"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Mon"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              this.state.routine.frequency &&
                              this.state.routine.frequency.includes('Tue')
                            }
                            onChange={this.handleChange('frequency')}
                            value="Tue"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Tue"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              this.state.routine.frequency &&
                              this.state.routine.frequency.includes('Wed')
                            }
                            onChange={this.handleChange('frequency')}
                            value="Wed"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Wed"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              this.state.routine.frequency &&
                              this.state.routine.frequency.includes('Thu')
                            }
                            onChange={this.handleChange('frequency')}
                            value="Thu"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Thu"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              this.state.routine.frequency &&
                              this.state.routine.frequency.includes('Fri')
                            }
                            onChange={this.handleChange('frequency')}
                            value="Fri"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Fri"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              this.state.routine.frequency &&
                              this.state.routine.frequency.includes('Sat')
                            }
                            onChange={this.handleChange('frequency')}
                            value="Sat"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Sat"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              this.state.routine.frequency &&
                              this.state.routine.frequency.includes('Sun')
                            }
                            onChange={this.handleChange('frequency')}
                            value="Sun"
                            style={{ color: 'lightblue' }}
                          />
                        }
                        label="Sun"
                      />
                    </FormGroup>
                  </ListItem>
                </List>
                {this.props.action !== 'add' && (
                  <GridList className="gridList" cols={4}>
                    {this.state.routine.groups &&
                      this.state.routine.groups.map((e, index) => (
                        <GridListTile
                          xs={6}
                          cols={1}
                          key={index}
                          style={{ height: 108 }}
                        >
                          <Paper
                            className="paperBlock"
                            style={{ borderRadius: 36 }}
                          >
                            <div
                              key={`bookblock-key-${index}`}
                              className="bookBlockChecked"
                              style={{
                                backgroundColor: e.color
                                  ? e.color
                                  : 'lightgrey',
                                opacity: 0.55
                              }}
                            >
                              <img
                                alt=""
                                className="iconTracker"
                                src={process.env.PUBLIC_URL + '/cloud_done.png'}
                              />
                              <Typography
                                variant="caption"
                                style={{
                                  paddingLeft: 2,
                                  paddingRight: 2,
                                  textAlign: 'center',
                                  fontSize: 12,
                                  color: 'grey',
                                  lineHeight: 1.1
                                }}
                              >
                                {e.name}
                              </Typography>
                            </div>
                            <div
                              onClick={() => this.handleRemove(e.id)}
                              className="iconBtnEditSmallX"
                            >
                              {this.state.loading ? (
                                <Loading />
                              ) : (
                                <RemoveIcon
                                  style={{
                                    color: 'lightgrey',
                                    fontSize: 14
                                  }}
                                />
                              )}
                            </div>
                          </Paper>
                        </GridListTile>
                      ))}
                    <GridListTile
                      xs={6}
                      cols={1}
                      key={'add'}
                      style={{ height: 90 }}
                    >
                      <Paper
                        className="paperBlock"
                        style={{ borderRadius: 36 }}
                        onClick={() => this.handleOpenGroups()}
                      >
                        <div
                          key={`bookblock-key-add`}
                          className="bookBlockChecked"
                          style={{ backgroundColor: 'white' }}
                        >
                          <img
                            alt=""
                            className="iconTracker"
                            src={process.env.PUBLIC_URL + '/cloud_done.png'}
                          />
                          <Typography
                            variant="body1"
                            id="bookName"
                            style={{
                              paddingLeft: 2,
                              paddingRight: 2,
                              textAlign: 'center',
                              fontSize: 12,
                              color: 'grey',
                              lineHeight: 1.1
                            }}
                          >
                            Add
                          </Typography>
                        </div>
                      </Paper>
                    </GridListTile>
                  </GridList>
                )}
                <List>
                  <ListItem className="modalContentDone">
                    {this.props.action === 'edit' && (
                      <Button
                        onClick={this.handleOpenDelete}
                        className="iconBtnCheck"
                        size="small"
                      >
                        {' '}
                        <span style={{ color: 'grey', fontSize: 15 }}>
                          Delete
                        </span>
                      </Button>
                    )}
                    <ListItemText />
                    <Button
                      onClick={this.handleClose}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>
                        Cancel
                      </span>
                    </Button>
                    <Button
                      onClick={this.handleSave}
                      className="iconBtnCheck"
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>Save</span>
                      {this.state.loadingSave ? (
                        <Loading />
                      ) : (
                        <ChevronRightIcon
                          style={{
                            color: 'grey',
                            fontSize: 20,
                            paddingLeft: 10
                          }}
                        />
                      )}
                    </Button>
                  </ListItem>
                </List>
              </div>
            )}
          </Paper>
        </Modal>
        <GroupsModal
          open={this.state.OpenGroups}
          onClose={this.handleCloseGroups}
          routine={this.state.routine}
          id={this.state.routine.id}
        />
        <DeleteModal
          open={this.state.OpenDelete}
          onClose={this.handleCloseDelete}
          yes={() => this.handleDelete(this.state.routine.id)}
          loading={this.state.loadingDel}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/RoutineEdit.js